export default __webpack_public_path__ + "static/Gem_hunter-7042407c0e5abfdc6f28ceba54a2d3c7.png";